import { Component, cloneElement } from 'react';
import { parse } from 'query-string';
import { withRouteData } from 'react-static';

import { DEFAULT_LOCALE, omitUrlParams, storageKeys } from '../helpers';

class Language extends Component {
  state = {
    locale: null,
  };

  async componentDidMount() {
    let locale = parse(window.location.search).locale;

    if (locale) {
      const { history } = this.props;
      const urlParams = omitUrlParams(['locale']);

      history.replace(
        `${history.location.pathname}${urlParams ? `?${urlParams}` : ''}`,
      );
    } else {
      locale =
        (await window.localStorage.getItem(storageKeys.LOCALE)) ||
        DEFAULT_LOCALE;
    }

    await window.localStorage.setItem(storageKeys.LOCALE, locale);
    this.setState(state => ({
      ...state,
      locale,
    }));
  }

  render() {
    const { locale } = this.state;

    return locale ? cloneElement(this.props.children, { lang: locale }) : null;
  }
}

export default withRouteData(Language);



// WEBPACK FOOTER //
// /app/apps/ms/src/providers/Language.js